import script from "./WIndicatorsStatisticPatients.vue?vue&type=script&setup=true&lang=ts"
export * from "./WIndicatorsStatisticPatients.vue?vue&type=script&setup=true&lang=ts"

import "./WIndicatorsStatisticPatients.vue?vue&type=style&index=0&id=2bb9c97c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb9c97c"]])

export default __exports__